import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/collect/rainv2_bg1.png'
import _imports_1 from '@/assets/collect/rainv2_star.png'
import _imports_2 from '@/assets/collect/rainv2_close.png'


const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = { class: "collect_Container" }

import StatusPopup from '@/components/common/statusPopup.vue'
import { ref, nextTick, onUnmounted, onMounted, watch } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'collectPopup',
  setup(__props, { expose: __expose }) {

const show = ref(false)
const statusPopupRef = ref()

const open = () => {
    show.value = true
}
const close = () => {
    show.value = false
}
const handleClick = () => {
    statusPopupRef.value.open()
}

__expose({
    open,
    close
})


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      position: "center",
      "overlay-style": { overflow: 'hidden' },
      style: {
        width: '100%',
        height: '100vh',
        color: '#fff',
        background: 'transparent',
        display:'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '10001'
    }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "",
              onClick: handleClick
            }),
            _createVNode(_component_van_row, { class: "row_section" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  class: "point_star",
                  span: "4"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("img", {
                      src: _imports_1,
                      alt: ""
                    }, null, -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  class: "point_text",
                  span: "20"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('collect.rechargedMembers')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  class: "point_star",
                  span: "4"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createElementVNode("img", {
                      src: _imports_1,
                      alt: ""
                    }, null, -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  class: "point_text",
                  span: "20"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('collect.maximumCachValue')) + " R$7.777. ", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", { class: "close_button" }, [
              _createElementVNode("img", {
                src: _imports_2,
                alt: "",
                onClick: close
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(StatusPopup, {
      ref_key: "statusPopupRef",
      ref: statusPopupRef,
      content: _ctx.$t('collect.depositCollector')
    }, null, 8, ["content"])
  ], 64))
}
}

})